/** A student's record (FR-TCH-5, docs/10 T-HIST): plan progress, recent results and attendance, from real data. */
import { z } from "zod";
import { AttendanceStatus } from "./attendance.js";
const date = z.iso.date();
export const StudentRecordQuery = z.object({ from: date, to: date });
export const PlanProgress = z.object({
    planId: z.uuid(),
    circle: z.object({ id: z.uuid(), name: z.string() }),
    start: z.string(),
    end: z.string(),
    provisional: z.boolean(),
    startedOn: z.string(),
    /** Ayahs of the range whose new-memorization items are passed, out of the range. */
    doneAyahs: z.number(),
    totalAyahs: z.number(),
    /** Items due up to `to`, by status. */
    due: z.object({
        passed: z.number(),
        repeat: z.number(),
        pending: z.number(),
        missed: z.number(),
        skipped: z.number(),
        /** Recited in part (B8-a); the rest is a later item. */
        partial: z.number(),
    }),
});
export const StudentRecordResponse = z.object({
    student: z.object({ id: z.uuid(), name: z.string() }),
    from: z.string(),
    to: z.string(),
    plans: z.array(PlanProgress),
    attendance: z.object({
        statuses: z.array(AttendanceStatus),
        counts: z.array(z.object({ statusId: z.uuid(), count: z.number() })),
        /** Days with a record, and those whose state counts as present (docs/05: attendance_rate). */
        recordedDays: z.number(),
        presentDays: z.number(),
    }),
    results: z.array(z.object({
        id: z.uuid(),
        recordedAt: z.string(),
        decision: z.enum(["passed", "repeat", "partial"]),
        kind: z.string().nullable(),
        range: z.string().nullable(),
        teacher: z.string(),
        revision: z.number(),
        errors: z.number(),
    })),
});
//# sourceMappingURL=record.js.map